export const isEanOrIsbn = (value: unknown): value is string => {
  return (
    typeof value === 'string' && (value.length === 13 || value.length === 10)
  );
};
